module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-11.95a9842a.svg";